import { useEffect, useState } from 'react'

const TYPING_SPEED = 80
const DELETING_SPEED = 40
const PAUSE_AFTER_TYPE = 2000
const PAUSE_AFTER_DELETE = 400

export function useTypewriter(words: string[]) {
  const [displayed, setDisplayed] = useState('')
  const [wordIndex, setWordIndex] = useState(0)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    const current = words[wordIndex % words.length]

    let timeout: ReturnType<typeof setTimeout>

    if (!isDeleting && displayed === current) {
      // Finished typing – pause then start deleting
      timeout = setTimeout(() => setIsDeleting(true), PAUSE_AFTER_TYPE)
    } else if (isDeleting && displayed === '') {
      // Finished deleting – move to next word
      timeout = setTimeout(() => {
        setIsDeleting(false)
        setWordIndex((i) => (i + 1) % words.length)
      }, PAUSE_AFTER_DELETE)
    } else if (isDeleting) {
      timeout = setTimeout(
        () => setDisplayed((d) => d.slice(0, -1)),
        DELETING_SPEED,
      )
    } else {
      timeout = setTimeout(
        () => setDisplayed(current.slice(0, displayed.length + 1)),
        TYPING_SPEED,
      )
    }

    return () => clearTimeout(timeout)
  }, [displayed, isDeleting, wordIndex, words])

  return displayed
}
